var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/more"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 14.75C3.98 14.75 2.75 13.52 2.75 12C2.75 10.48 3.98 9.25 5.5 9.25C7.02 9.25 8.25 10.48 8.25 12C8.25 13.52 7.02 14.75 5.5 14.75ZM5.5 10.75C4.81 10.75 4.25 11.31 4.25 12C4.25 12.69 4.81 13.25 5.5 13.25C6.19 13.25 6.75 12.69 6.75 12C6.75 11.31 6.19 10.75 5.5 10.75Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.5 14.75C17.98 14.75 16.75 13.52 16.75 12C16.75 10.48 17.98 9.25 19.5 9.25C21.02 9.25 22.25 10.48 22.25 12C22.25 13.52 21.02 14.75 19.5 14.75ZM19.5 10.75C18.81 10.75 18.25 11.31 18.25 12C18.25 12.69 18.81 13.25 19.5 13.25C20.19 13.25 20.75 12.69 20.75 12C20.75 11.31 20.19 10.75 19.5 10.75Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 14.75C10.98 14.75 9.75 13.52 9.75 12C9.75 10.48 10.98 9.25 12.5 9.25C14.02 9.25 15.25 10.48 15.25 12C15.25 13.52 14.02 14.75 12.5 14.75ZM12.5 10.75C11.81 10.75 11.25 11.31 11.25 12C11.25 12.69 11.81 13.25 12.5 13.25C13.19 13.25 13.75 12.69 13.75 12C13.75 11.31 13.19 10.75 12.5 10.75Z",
    fill: "#344054"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.ad33585259c3fbadeb0de8475cff5a26.svg";
export { ForwardRef as ReactComponent };